/**
 * Cheelee Public API Docs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyPair } from './currencyPair';


export interface GetCurrencyPairsByTsRespResult { 
    currency_pairs?: Array<CurrencyPair>;
    created_at?: string;
}

